import React from 'react'
import PropTypes from 'prop-types'
import tw, { styled } from 'twin.macro'

const Banner = styled.div`
	${tw`bg-yellow-500 text-white py-2 px-2 md:px-4 text-center overflow-hidden`}
`

const BannerContent = styled.div`
	${tw`container mx-auto flex items-center justify-center flex-wrap gap-2 md:gap-4`}
`

const BannerItem = styled.div`
	${tw`text-xs md:text-sm lg:text-base font-bold`}
	white-space: nowrap;

	&:not(:last-child)::after {
		content: '|';
		${tw`ml-2 md:ml-4 text-white opacity-50`}
	}
`

/**
 * TopBanner - Promotional banner at the top of the page
 * @param {Object} props
 * @param {Array<string>} props.items - Array of promotional text items
 */
const TopBanner = ({ items }) => {
	return (
		<Banner>
			<BannerContent>
				{items.map((item, index) => (
					<BannerItem key={index}>{item}</BannerItem>
				))}
			</BannerContent>
		</Banner>
	)
}

TopBanner.propTypes = {
	items: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default TopBanner
